const All_products = [
  {
    id: 0,
    category: "Chikki",
    products: [
      {
        name: "Crush peanut chikki",
        price: "10",
        image: "/assets/images/products/chikki/crush-peanut-chikki.png",
        amazon_link: "https://www.amazon.in/",
        bigbasket_link: "https://www.bigbasket.com/",
        blinkit_link: "https://blinkit.com/",
        flipcart_link: "https://www.flipkart.com/",
      },
      {
        name: "Mawa peanut chikki",
        price: "50",
        image: "/assets/images/products/chikki/mawa-peanut-chikki.png",
        amazon_link: "https://www.amazon.in/",
        bigbasket_link: "https://www.bigbasket.com/",
        blinkit_link: "https://blinkit.com/",
        flipcart_link: "https://www.flipkart.com/",
      },
      {
        name: "Peanut chikki",
        price: "10",
        image: "/assets/images/products/chikki/peanut-chikki.png",
        amazon_link: "https://www.amazon.in/",
        bigbasket_link: "https://www.bigbasket.com/",
        blinkit_link: "https://blinkit.com/",
        flipcart_link: "https://www.flipkart.com/",
      },
      {
        name: "Rajgeera peanut chikki",
        price: "50",
        image: "/assets/images/products/chikki/rajgeera-peanut-chikki.png",
        amazon_link: "https://www.amazon.in/",
        bigbasket_link: "https://www.bigbasket.com/",
        blinkit_link: "https://blinkit.com/",
        flipcart_link: "https://www.flipkart.com/",
      },
      {
        name: "Crush peanut chikki",
        price: "10",
        image: "/assets/images/products/chikki/crush-peanut-chikki.png",
        amazon_link: "https://www.amazon.in/",
        bigbasket_link: "https://www.bigbasket.com/",
        blinkit_link: "https://blinkit.com/",
        flipcart_link: "https://www.flipkart.com/",
      },
      {
        name: "Mawa peanut chikki",
        price: "50",
        image: "/assets/images/products/chikki/mawa-peanut-chikki.png",
        amazon_link: "https://www.amazon.in/",
        bigbasket_link: "https://www.bigbasket.com/",
        blinkit_link: "https://blinkit.com/",
        flipcart_link: "https://www.flipkart.com/",
      },
      {
        name: "Peanut chikki",
        price: "10",
        image: "/assets/images/products/chikki/peanut-chikki.png",
        amazon_link: "https://www.amazon.in/",
        bigbasket_link: "https://www.bigbasket.com/",
        blinkit_link: "https://blinkit.com/",
        flipcart_link: "https://www.flipkart.com/",
      },
      {
        name: "Rajgeera peanut chikki",
        price: "50",
        image: "/assets/images/products/chikki/rajgeera-peanut-chikki.png",
        amazon_link: "https://www.amazon.in/",
        bigbasket_link: "https://www.bigbasket.com/",
        blinkit_link: "https://blinkit.com/",
        flipcart_link: "https://www.flipkart.com/",
      },
    ],
  },

  {
    id: 1,
    category: "Ladoo",
    products: [
      {
        name: "Premium Chocolate peanut Ladoo",
        price: "10",
        image:
          "/assets/images/products/ladu/Premium-Chocolate-peanut-Ladoo.png",
        amazon_link: "https://www.amazon.in/",
        bigbasket_link: "https://www.bigbasket.com/",
        blinkit_link: "https://blinkit.com/",
        flipcart_link: "https://www.flipkart.com/",
      },
      {
        name: "Premium shengdana ladu",
        price: "50",
        image: "/assets/images/products/ladu/premium-shengdana-ladu.png",
        amazon_link: "https://www.amazon.in/",
        bigbasket_link: "https://www.bigbasket.com/",
        blinkit_link: "https://blinkit.com/",
        flipcart_link: "https://www.flipkart.com/",
      },
      {
        name: "Shengdana ladu",
        price: "10",
        image: "/assets/images/products/ladu/shengdana-ladu.png",
        amazon_link: "https://www.amazon.in/",
        bigbasket_link: "https://www.bigbasket.com/",
        blinkit_link: "https://blinkit.com/",
        flipcart_link: "https://www.flipkart.com/",
      },
      {
        name: "Shengdana peanut ladu",
        price: "50",
        image: "/assets/images/products/ladu/shengdana-peanut-ladu.png",
        amazon_link: "https://www.amazon.in/",
        bigbasket_link: "https://www.bigbasket.com/",
        blinkit_link: "https://blinkit.com/",
        flipcart_link: "https://www.flipkart.com/",
      },
    ],
  },

  {
    id: 2,
    category: "Khakhra",
    products: [
      {
        name: "Premium Chocolate peanut Ladoo",
        price: "10",
        image:
          "/assets/images/products/ladu/Premium-Chocolate-peanut-Ladoo.png",
        amazon_link: "https://www.amazon.in/",
        bigbasket_link: "https://www.bigbasket.com/",
        blinkit_link: "https://blinkit.com/",
        flipcart_link: "https://www.flipkart.com/",
      },
      {
        name: "Premium shengdana ladu",
        price: "50",
        image: "/assets/images/products/ladu/premium-shengdana-ladu.png",
        amazon_link: "https://www.amazon.in/",
        bigbasket_link: "https://www.bigbasket.com/",
        blinkit_link: "https://blinkit.com/",
        flipcart_link: "https://www.flipkart.com/",
      },
      {
        name: "Shengdana ladu",
        price: "10",
        image: "/assets/images/products/ladu/shengdana-ladu.png",
        amazon_link: "https://www.amazon.in/",
        bigbasket_link: "https://www.bigbasket.com/",
        blinkit_link: "https://blinkit.com/",
        flipcart_link: "https://www.flipkart.com/",
      },
      {
        name: "Shengdana peanut ladu",
        price: "50",
        image: "/assets/images/products/ladu/shengdana-peanut-ladu.png",
        amazon_link: "https://www.amazon.in/",
        bigbasket_link: "https://www.bigbasket.com/",
        blinkit_link: "https://blinkit.com/",
        flipcart_link: "https://www.flipkart.com/",
      },
    ],
  },

  {
    id: 3,
    category: "Beverages",
    products: [
      {
        name: "Premium Chocolate peanut Ladoo",
        price: "10",
        image:
          "/assets/images/products/ladu/Premium-Chocolate-peanut-Ladoo.png",
        amazon_link: "https://www.amazon.in/",
        bigbasket_link: "https://www.bigbasket.com/",
        blinkit_link: "https://blinkit.com/",
        flipcart_link: "https://www.flipkart.com/",
      },
      {
        name: "Premium shengdana ladu",
        price: "50",
        image: "/assets/images/products/ladu/premium-shengdana-ladu.png",
        amazon_link: "https://www.amazon.in/",
        bigbasket_link: "https://www.bigbasket.com/",
        blinkit_link: "https://blinkit.com/",
        flipcart_link: "https://www.flipkart.com/",
      },
      {
        name: "Shengdana ladu",
        price: "10",
        image: "/assets/images/products/ladu/shengdana-ladu.png",
        amazon_link: "https://www.amazon.in/",
        bigbasket_link: "https://www.bigbasket.com/",
        blinkit_link: "https://blinkit.com/",
        flipcart_link: "https://www.flipkart.com/",
      },
      {
        name: "Shengdana peanut ladu",
        price: "50",
        image: "/assets/images/products/ladu/shengdana-peanut-ladu.png",
        amazon_link: "https://www.amazon.in/",
        bigbasket_link: "https://www.bigbasket.com/",
        blinkit_link: "https://blinkit.com/",
        flipcart_link: "https://www.flipkart.com/",
      },
    ],
  },
];

export default All_products;
